import { render } from "./diet-selection.vue?vue&type=template&id=8e966176&ts=true"
import script from "./diet-selection.vue?vue&type=script&lang=ts"
export * from "./diet-selection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__